/**
 * Optimized Metaobject Bundle Cart Addition for Collection Pages
 * Handles extracting bundle data and adding all items (parent + children) to cart in one go
 */

window.CollectionBundleCart = {
    
    showCartFlyout(itemResponse, cartData, button) {
        const flyOutTemplate = document.querySelector('[data-templates] [data-atc-banner]');
        if (!flyOutTemplate) {
            return;
        }
        
        const flyOut = flyOutTemplate.cloneNode(true);
        const quantity = itemResponse.quantity || 1;
        
        if (itemResponse.image) {
            const imageUrl = itemResponse.image.replace(/(\.[^.]+)$/, '_200x$1');
            const productImage = flyOut.querySelector('[data-atc-banner-product-image]');
            if (productImage) {
                productImage.innerHTML = '<img src="' + imageUrl + '" alt="' + (itemResponse.product_title || '') + '">';
            }
        }
        
        const productTitle = flyOut.querySelector('[data-atc-banner-product-title]');
        if (productTitle) {
            productTitle.innerHTML = itemResponse.product_title || '';
        }
        
        if (itemResponse.variant_options && itemResponse.variant_options[0] !== 'Title' && itemResponse.variant_options[0] !== 'Default Title') {
            const productOptions = flyOut.querySelector('[data-atc-banner-product-options]');
            if (productOptions) {
                productOptions.innerHTML = itemResponse.variant_options.join(', ');
            }
        }
        
        const productPriceQuantity = flyOut.querySelector('[data-atc-banner-product-price-quantity]');
        if (productPriceQuantity) {
            productPriceQuantity.innerHTML = quantity + ' × ';
        }
        
        const price = itemResponse.price / 100;
        const productPriceValue = flyOut.querySelector('[data-atc-banner-product-price-value]');
        if (productPriceValue) {
            productPriceValue.innerHTML = '$' + price.toFixed(2);
        }
        
        const subTotal = flyOut.querySelector('[data-atc-banner-cart-subtotal]');
        if (subTotal && cartData) {
            const cartTotal = cartData.total_price / 100;
            subTotal.innerHTML = '$' + cartTotal.toFixed(2);
        }
        
        const itemCount = flyOut.querySelector('[data-atc-banner-cart-button] span');
        if (itemCount && cartData) {
            let mainItemCount = 0;
            const items = cartData.items || [];
            items.forEach(function(item) {
                const props = item.properties || {};
                const isBundleChild = props._boldBuilderId && !props._boldVariantIds;
                if (!isBundleChild) {
                    mainItemCount += item.quantity;
                }
            });
            itemCount.innerHTML = mainItemCount;
        }
        
        const header = document.querySelector('[data-site-header]');
        if (header) {
            const existingFlyout = header.querySelector('[data-atc-banner]');
            if (existingFlyout) {
                existingFlyout.remove();
            }
            header.appendChild(flyOut);
            flyOut.setAttribute('aria-hidden', 'false');
        }
        
        const closeButton = flyOut.querySelector('[data-atc-banner-close]');
        const closeButton1 = flyOut.querySelector('[data-atc-banner-close1]');
        
        const closeFlyout = function() {
            flyOut.setAttribute('aria-hidden', 'true');
            setTimeout(function() {
                if (flyOut.parentNode) {
                    flyOut.remove();
                }
            }, 300);
        };
        
        if (closeButton) {
            closeButton.addEventListener('click', closeFlyout);
        }
        if (closeButton1) {
            closeButton1.addEventListener('click', closeFlyout);
        }
        
        setTimeout(closeFlyout, 5000);
    },
    
    updateCartCountManually(cartData) {
        
        // Calculate main item count (excluding bundle child items) - matches theme logic
        const items = cartData && Array.isArray(cartData.items) ? cartData.items : [];
        let mainItemCount = 0;
        
        items.forEach(item => {
            const props = item.properties || {};
            const hasProps = props && Object.keys(props).length > 0;
            // Child items have _boldBuilderId but NOT _boldVariantIds
            const isBundleChild = hasProps && typeof props._boldBuilderId !== 'undefined' && typeof props._boldVariantIds === 'undefined';
            
            if (!isBundleChild) {
                mainItemCount += item.quantity || 0;
            }
        });
        
        const displayCount = mainItemCount || cartData.item_count || items.length || 0;
        
        // Update cart count elements - use data attribute like theme does
        const headerCountEl = document.querySelector('.site-header-cart--count');
        if (headerCountEl) {
            headerCountEl.setAttribute('data-header-cart-count', displayCount);
        }
        
        // Also update any text elements
        const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart__count');
        cartCountElements.forEach(el => {
            el.textContent = displayCount;
        });
        
        // Trigger custom cart update event
        const cartUpdateEvent = new CustomEvent('cart:updated', {
            detail: { cart: cartData }
        });
        document.dispatchEvent(cartUpdateEvent);
        
    },
    
    /**
     * Add bundle to cart with all child items
     * @param {HTMLElement} form - The product form element
     * @param {HTMLElement} button - The add to cart button
     * @returns {Promise} - Resolves when all items are added
     */
    async addBundleToCart(form, button) {
        const startTime = performance.now();
        
        try {
            // Show processing state
            button.classList.add('processing');
            button.disabled = true;
            
            // Get product ID
            const productCard = form.closest('[attr-prod-id]');
            const productId = productCard ? productCard.getAttribute('attr-prod-id') : null;
            
            if (!productId) {
                throw new Error('Product ID not found');
            }
            
            
            // Check if this is a metaobject bundle
            const isMetaobjectBundle = window.collectionBundleData && window.collectionBundleData[productId];
            
            // Extract form data
            const formData = new FormData(form);
            const parentQuantity = parseInt(formData.get('quantity') || '1');
            const parentVariantId = formData.get('id');
            
            
            // Extract bundle properties
            const bundleVariantIds = formData.get('properties[_boldVariantIds]');
            const bundleVariantQtys = formData.get('properties[_boldVariantQtys]');
            const bundleBuilderId = formData.get('properties[_boldBuilderId]');
            const bundleProductIds = formData.get('properties[_boldProductIds]');
            const bundleVariantNames = formData.get('properties[_boldVariantNames]');
            
            
            // Prepare parent item
            const parentItem = {
                id: parseInt(parentVariantId),
                quantity: parentQuantity,
                properties: {}
            };
            
            // Add all form properties to parent item
            for (let [key, value] of formData.entries()) {
                if (key.startsWith('properties[') && key !== 'properties[quantity]') {
                    const propName = key.replace('properties[', '').replace(']', '');
                    parentItem.properties[propName] = value;
                }
            }
                        
            // Prepare child items array
            const childItems = [];
            
            if (bundleVariantIds && bundleBuilderId) {
                const variantIds = bundleVariantIds.split(',').map(id => id.trim()).filter(id => id);
                const quantities = bundleVariantQtys ? bundleVariantQtys.split(',').map(q => parseInt(q.trim()) || 1) : [];
                const productIds = bundleProductIds ? bundleProductIds.split(',').map(id => id.trim()) : [];
                const variantNames = bundleVariantNames ? bundleVariantNames.split(',').map(name => name.trim()) : [];
                
                
                // Create child items with parent quantity multiplier
                variantIds.forEach((variantId, index) => {
                    if (variantId && variantId !== 'undefined' && variantId !== '') {
                        const childQty = (quantities[index] || 1) * parentQuantity;
                        const childItem = {
                            id: parseInt(variantId),
                            quantity: childQty,
                            properties: {
                                '_boldBuilderId': bundleBuilderId,
                                '_boldIsChildItem': 'true',
                                '_bundleSource': 'metaobject'
                            }
                        };
                        
                        if (variantNames[index]) {
                            childItem.properties['_boldVariantName'] = variantNames[index];
                        }
                        if (productIds[index]) {
                            childItem.properties['_boldProductId'] = productIds[index];
                        }
                        
                        childItems.push(childItem);
                    }
                });
            }
                        
            // Add parent item first
            const parentResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(parentItem)
            });
            
            if (!parentResponse.ok) {
                const errorData = await parentResponse.json().catch(() => ({}));
                throw new Error(errorData.description || `Failed to add parent item: ${parentResponse.status}`);
            }
            
            const parentResult = await parentResponse.json();
            
            // Add child items if any
            if (childItems.length > 0) {
                
                const childResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ items: childItems })
                });
                
                if (!childResponse.ok) {
                    const errorData = await childResponse.json().catch(() => ({}));
                    console.warn('[Bundle Cart] Batch add failed, trying sequential...', errorData);
                    
                    // Fallback to sequential adds
                    for (let i = 0; i < childItems.length; i++) {
                        try {
                            const itemResponse = await fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(childItems[i])
                            });
                            
                            if (itemResponse.ok) {
                                const itemResult = await itemResponse.json();
                            } else {
                                console.error(`[Bundle Cart] Failed to add child item ${i + 1}:`, await itemResponse.text());
                            }
                        } catch (error) {
                            console.error(`[Bundle Cart] Error adding child item ${i + 1}:`, error);
                        }
                    }
                } else {
                    const childResult = await childResponse.json();
                }
            }
            
            // Get updated cart
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();
            
            const endTime = performance.now();
            // Remove processing state
            button.classList.remove('processing');
            button.disabled = false;
            
            if (typeof window.cart_update_count !== 'undefined' && typeof $ !== 'undefined') {
                try {
                    window.cart_update_count(parentResult, 'custom', $(button));
                } catch (error) {
                    console.warn('[Collection Bundle Cart] cart_update_count failed, using fallback:', error.message);
                    this.updateCartCountManually(cartData);
                    this.showCartFlyout(parentResult, cartData, button);
                }
            } else {
                this.updateCartCountManually(cartData);
                this.showCartFlyout(parentResult, cartData, button);
            }
            
            return {
                success: true,
                parentItem: parentResult,
                childItems: childItems.length,
                cart: cartData
            };
            
        } catch (error) {
            console.error('[Bundle Cart] Error adding bundle to cart:', error);
            
            // Remove processing state
            button.classList.remove('processing');
            button.disabled = false;
            
            // Show error message
            alert(`Error adding bundle to cart: ${error.message}`);
            
            return {
                success: false,
                error: error.message
            };
        }
    }
};


